import { render, staticRenderFns } from "./ComponentStats.vue?vue&type=template&id=1d0dc0f0&scoped=true&"
import script from "./ComponentStats.vue?vue&type=script&lang=js&"
export * from "./ComponentStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0dc0f0",
  null
  
)

export default component.exports